import { useEffect, useState } from 'react';
import { DBRequest, useConfig } from '../../../api/api';
import { Box, Divider } from '@mui/material';
import TypeCustomSelect from '../../../components/form/form-fields/TypeCustomSelect';
import { useTranslation } from 'react-i18next';
import { SalesObjectPreview } from '../../../open-scenes/sales-object-customer-view/SalesObjectPreview';
import Loader from '../../../components/special/Loader';

export const SalesObjectCustomerPreview = ({ salesObject }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const [level, setLevel] = useState(0);
  const [previewData, setPreviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleLoadCustomerPreview(level);
  }, [salesObject, config]);

  function handleLoadCustomerPreview(newLevel) {
    DBRequest({
      config,
      path: `sales-objects/${salesObject.id}/preview/${newLevel}`,
      onResponse: setPreviewData,
      onLoading: setIsLoading,
    });
  }

  function handleChange(key, value) {
    setLevel(value);
    handleLoadCustomerPreview(value);
  }

  const options = [
    {
      label: (
        <>
          <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
            0
          </span>
          {` - ${t('Start level')}`}
        </>
      ),
      value: 0,
    },
    {
      label: (
        <>
          <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
            1
          </span>
          {` - ${t('Sales level')}`}
        </>
      ),
      value: 1,
    },
    {
      label: (
        <>
          <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
            2
          </span>
          {` - ${t('Sales level')}`}
        </>
      ),
      value: 2,
    },
    {
      label: (
        <>
          <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
            3
          </span>
          {` - ${t('Sales level')}`}
        </>
      ),
      value: 3,
    },
    {
      label: (
        <>
          <span className="monospace  mr-1" style={{ fontWeight: 600 }}>
            4
          </span>
          {` - ${t('Sales level')}`}
        </>
      ),
      value: 4,
    },
  ];

  return (
    <Box className="h-full flex flex-col w-full justify-center gap-2 relative pt-2">
      <Loader active={isLoading} />
      <TypeCustomSelect
        field={{
          label: t('Sales level'),
          key: 'level',
          options,
          noUnselect: true,
        }}
        dataCollection={{ level }}
        updateValidationOnChange={handleChange}
      />
      <Divider />
      <Box className="h-full flex flex-col overflow-y-auto">
        <SalesObjectPreview salesObject={previewData?.data} />
      </Box>
    </Box>
  );
};
